// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2SIk0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__vR8Q5","obliqueLine":"membershipbadge_obliqueLine__32hzj"};